import '../../App.css';
import styled from 'styled-components';
import { CircledImageProps } from '../common/types';
import { CircleBgProps} from '../common/types';
import Image from '../common/CircularImgProps';
import React from 'react';

const Circle = styled.div<CircleBgProps>`
  width: ${({ $circleBgSize, $circleBgWidth }) => $circleBgSize || $circleBgWidth || '50px'};
  height: ${({ $circleBgSize, $circleBgHeight }) => $circleBgSize || $circleBgHeight || '50px'};
  background-color: ${({ theme }) => theme.circularIconBg};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden; /* Ensures the image stays within the circle */
  margin: 0 10px;
`;

function CircleIcon({ ...props }: CircledImageProps) {
    return(
        <Circle $circleBgHeight={props.$circleBgHeight} $circleBgWidth={props.$circleBgWidth} $circleBgSize={props.$circleBgSize}>
            <Image src={props.$imageUrl} alt={props.$altText || 'Circle Icon'} $imgHeight={props.$imgHeight} $imgWidth={props.$imgWidth} $imgSize={props.$imgSize}/>
        </Circle>
    )
}

export default React.memo(CircleIcon)